import { SVGProps } from "react";

interface IconProps extends SVGProps<SVGSVGElement> {
  fillColor?: string;
}

const WarningTriangleIcon = ({
  className,
  fillColor = "#FFD100",
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      d="M11.0504 2.61978C10.9467 2.43202 10.7945 2.2755 10.6098 2.1665C10.4251 2.05749 10.2145 2 10 2C9.78545 2 9.57489 2.05749 9.39016 2.1665C9.20544 2.2755 9.05328 2.43202 8.9496 2.61978L1.14948 17.0199C1.04861 17.2027 0.997133 17.4085 1.00012 17.6172C1.00311 17.8258 1.06047 18.0301 1.16653 18.2098C1.27259 18.3896 1.42368 18.5385 1.60491 18.642C1.78613 18.7455 1.9912 18.8 2.19989 18.8H17.8001C18.0087 18.8 18.2139 18.7455 18.3951 18.642C18.5763 18.5385 18.7274 18.3896 18.8335 18.2098C18.9395 18.0301 18.9968 17.8258 18.9999 17.6172C19.0028 17.4085 18.9513 17.2027 18.8505 17.0199L11.0504 2.61978Z"
      fill={fillColor}
    />
    <path d="M10 12.7997V7.39966V12.7997Z" fill={fillColor} />
    <path
      d="M10 12.7997V7.39966M10 15.4H10.1M11.0504 2.61978C10.9467 2.43202 10.7945 2.2755 10.6098 2.1665C10.4251 2.05749 10.2145 2 10 2C9.78545 2 9.57489 2.05749 9.39016 2.1665C9.20544 2.2755 9.05328 2.43202 8.9496 2.61978L1.14948 17.0199C1.04861 17.2027 0.997133 17.4085 1.00012 17.6172C1.00311 17.8258 1.06047 18.0301 1.16653 18.2098C1.27259 18.3896 1.42368 18.5385 1.60491 18.642C1.78613 18.7455 1.9912 18.8 2.19989 18.8H17.8001C18.0087 18.8 18.2139 18.7455 18.3951 18.642C18.5763 18.5385 18.7274 18.3896 18.8335 18.2098C18.9395 18.0301 18.9968 17.8258 18.9999 17.6172C19.0028 17.4085 18.9513 17.2027 18.8505 17.0199L11.0504 2.61978Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default WarningTriangleIcon;
